/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TTLORuleDateTimeRestriction,
    TTLORuleDateTimeRestrictionFromJSON,
    TTLORuleDateTimeRestrictionFromJSONTyped,
    TTLORuleDateTimeRestrictionToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLODateTimeRestriction
 */
export interface TTLODateTimeRestriction {
    /**
     * 
     * @type {TTLORuleDateTimeRestriction}
     * @memberof TTLODateTimeRestriction
     */
    ruleDateTimeRestriction?: TTLORuleDateTimeRestriction;
    /**
     * 
     * @type {number}
     * @memberof TTLODateTimeRestriction
     */
    order?: number;
}

export function TTLODateTimeRestrictionFromJSON(json: any): TTLODateTimeRestriction {
    return TTLODateTimeRestrictionFromJSONTyped(json, false);
}

export function TTLODateTimeRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLODateTimeRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ruleDateTimeRestriction': !exists(json, 'ruleDateTimeRestriction') ? undefined : TTLORuleDateTimeRestrictionFromJSON(json['ruleDateTimeRestriction']),
        'order': !exists(json, 'order') ? undefined : json['order'],
    };
}

export function TTLODateTimeRestrictionToJSON(value?: TTLODateTimeRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ruleDateTimeRestriction': TTLORuleDateTimeRestrictionToJSON(value.ruleDateTimeRestriction),
        'order': value.order,
    };
}


